module.exports = __webpack_public_path__ + "img/TECNOLOGIA-CIAZ-2.65f9f6b3.jpg";